export const URL_CURRENCY_PARAM_KEY = 'cur';
export const SELECTED_CURRENCY_STORAGE_KEY = 'selectedCurrencyCode';
export const EXCHANGE_RATES_STORAGE_KEY = 'exchangeRates';
